(() => {
  const key = 'raymae_saved_products';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string'))] : [];
    } catch {
      return [];
    }
  };
  let status;
  const update = button => {
    const active = read().includes(button.dataset.productHandle);
    const label = active ? button.dataset.savedLabel || 'Saved' : button.dataset.saveLabel || 'Save for later';
    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', `${label} — ${button.dataset.productTitle || button.dataset.productHandle}`);
    button.title = label;
    const text = button.querySelector('[data-rm-wishlist-label]');
    if (text && text.textContent !== label) text.textContent = label;
    button.hidden = false;
  };
  const refresh = () => document.querySelectorAll('[data-rm-wishlist]').forEach(update);
  const init = () => {
    status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    document.body.append(status);
    refresh();
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-rm-wishlist]');
      if (!button) return;
      event.preventDefault();
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const items = read();
      const index = items.indexOf(handle);
      if (index >= 0) items.splice(index, 1);
      else items.push(handle);
      try {
        localStorage.setItem(key, JSON.stringify(items));
        refresh();
        status.textContent = button.getAttribute('aria-label');
        document.dispatchEvent(new CustomEvent('raymae:saved-change'));
      } catch {
        status.textContent = button.dataset.errorLabel;
      }
    });
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-rm-wishlist]') || node.querySelector('[data-rm-wishlist]'))))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', event => { if (event.key === key) refresh(); });
    window.addEventListener('pageshow', refresh);
    document.addEventListener('raymae:saved-change', refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
